"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _stringField = _interopRequireDefault(require("./stringField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var stringArrayField = function stringArrayField(array, options) {
  if (!Array.isArray(array)) return '';
  var value = array.filter(function (element) {
    return typeof element === 'string' && !!element;
  }).map(function (element) {
    var formattedString = (0, _stringField["default"])(element);
    return formattedString.replace(/,/g, '_');
  });
  if (options !== null && options !== void 0 && options.shouldSort) value = value.sort(function (a, b) {
    return a > b ? 1 : -1;
  });
  return value.join((options === null || options === void 0 ? void 0 : options.separator) || ',');
};
var _default = exports["default"] = stringArrayField;